document.addEventListener('DOMContentLoaded', function () {
	const toggles = document.querySelectorAll('.program-toggle');
	console.log('here');
	toggles.forEach((btn) => {
		btn.addEventListener('click', function () {
			const program = btn.nextElementSibling;
			if (!program) return;

			program.classList.toggle('open');

			// rotate arrow
			const arrow = btn.querySelector('.arrow');
			arrow.classList.toggle('down');
			// if (program.classList.contains('open')) {
			// 	arrow.style.transform = 'rotate(180deg)';
			// } else {
			// 	arrow.style.transform = 'rotate(0deg)';
			// }
		});
	});
});
